import React from 'react';

import { Accordion } from '@base-ui/react/accordion';
import { ChevronDownIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';

import st from './ViewCard.module.sass';

interface ViewCardProps {
  /** Уникальный идентификатор карточки в рамках секции (значение accordion item). */
  value: string;
  /** Содержимое заголовочной строки карточки. */
  header: React.ReactNode;
  /** Развёрнута ли карточка по умолчанию (выключенные блоки сворачиваем). */
  defaultOpen?: boolean;
  children?: React.ReactNode;
}

function ViewCard({
  value,
  header,
  defaultOpen = true,
  children = undefined,
}: ViewCardProps): React.JSX.Element {
  // Пустые строки очищены секциями (null) — аккордеон без контента не нужен:
  // рендерим только заголовок без панели и триггера сворачивания
  const hasContent = React.Children.toArray(children).some(Boolean);

  if (!hasContent) {
    return (
      <div className={st.Item}>
        <div className={st.Header}>
          <span className={st.HeaderContent}>{header}</span>
        </div>
      </div>
    );
  }

  return (
    <Accordion.Root
      className={st.Root}
      defaultValue={defaultOpen ? [value] : []}
      multiple
    >
      <Accordion.Item
        className={st.Item}
        value={value}
      >
        <Accordion.Header className={st.Header}>
          <span className={st.HeaderContent}>{header}</span>
          <Accordion.Trigger
            className={st.Trigger}
            render={(
              <Control.IconButton
                icon={<ChevronDownIcon className={st.Chevron} />}
                kind="secondary"
                shape="round"
                size="small"
                variant="dimmed"
              />
            )}
          />
        </Accordion.Header>
        <Accordion.Panel className={st.Panel}>{children}</Accordion.Panel>
      </Accordion.Item>
    </Accordion.Root>
  );
}

export { ViewCard };
